import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "../../../components/forms/Buttons/Button";
import { PencilSquareIcon, TrashIcon } from "@heroicons/react/24/outline";

export const useExamCenterColumns = (handleEdit, handleDelete) => {
  const [t] = useTranslation();

  return useMemo(
    () => [
      {
        Header: t("admin.exam_center_name"),
        accessor: "name",
      },
      {
        Header: t("admin.region"),
        accessor: "region",
        Cell: ({ value }) => value?.name || "-",
      },
      {
        Header: t("admin.is_full"),
        accessor: "is_full",
        Cell: ({ value }) => (value ? t("admin.yes") : t("admin.no")),
      },
      {
        Header: t("admin.approved_teams_count"),
        accessor: "approved_teams_count",
        Cell: ({ value }) => value || 0,
      },
      {
        Header: t("admin.draft_teams_count"),
        accessor: "draft_teams_count",
        Cell: ({ value }) => value || 0,
      },
      {
        Header: t("admin.actions"),
        accessor: "uuid",
        Cell: ({ row }) => (
          <div className="flex gap-2">
            <Button
              Icon={PencilSquareIcon}
              onClick={() => handleEdit(row.original)}
              color="primary"
            />
            <Button
              Icon={TrashIcon}
              onClick={() => handleDelete(row.original)}
              color="error"
            />
          </div>
        ),
      },
    ],
    [t, handleEdit, handleDelete]
  );
};
